export const isTestEnvironment = () => {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || 
           hostname === 'web-eventos-test.lacnic.net';
};